<template>
  <div id="LOGO1"></div>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.a {
  text-decoration: none;
}
#LOGO1 {
  display: none;
  background-repeat: no-repeat;
  background-size: 100%;
}
</style>